export function StatusPill({ status }) {
  const map = {
    pending: { bg: "var(--peach-tint)", col: "var(--primary)" },
    approved: { bg: "rgba(16,185,129,0.15)", col: "var(--success)" },
    rejected: { bg: "rgba(239,68,68,0.15)", col: "var(--error)" },
    paid: { bg: "rgba(16,185,129,0.15)", col: "var(--success)" },
  };
  const s = map[status] || map.pending;
  return (
    <span className="pill" style={{ background: s.bg, borderColor: s.col, color: s.col }}>
      {status}
    </span>
  );
}
